import { Backdrop, CircularProgress, FormControl, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../../../asset/svg/leftArrow.svg';
import SearchIcon from '@mui/icons-material/Search';
import SelectStoreLocationIcon from '../../../../../asset/svg/SelectStoreLocationIcon.svg';
import NoStoresIcon from '../../../../../asset/svg/NoStoresIcon.svg';
import '../../../../../scss/pages/Attendance/Component/Checklist/SelectStoreChecklist/SelectStoreChecklist.scss'
import { useNavigate } from 'react-router';
import { CHECKLIST_PLANNER_PATH, SELECT_CHECKLIST_PATH } from '../../../../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CHECKLIST_DATA, GET_CHECKLIST_STORE_DATA } from '../../../../../sagas/type';

function SelectStoreChecklist() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { getStores } = useSelector(mapStateToProps)
    const [searchName, setSearchName] = useState('');
    const [loader, setLoader] = useState(false)
    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }
    const getStoreData = () => {
        setLoader(true)
        dispatch({
            type: GET_CHECKLIST_STORE_DATA,
            setLoader: setLoader,
        })
    }

    useEffect(() => {
        getStoreData();
    }, [])

    const handleBack = () => {
        navigate(CHECKLIST_PLANNER_PATH)
    }

    const handleSelectStore = (selectData) => {
        navigate(SELECT_CHECKLIST_PATH, { state: { selectStore: selectData } })
        dispatch({
            type: GET_CHECKLIST_DATA,
            setLoader: setLoader,
        })
    }
    return (
        <div className='SelectStore-checklist'>
            <div className='SelectStore-checklist_header'>
                <div>
                    <img className='SelectStore-checklist_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='SelectStore-checklist_header_content'>Select Store</span>
                </div>
            </div>
            <div className='SelectStore-checklist_searchcontainer'>
                <FormControl sx={{ width: '270px', backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                    <TextField autoComplete="off" size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                        InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                </FormControl>
            </div>
            {loader ? <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
                :
                <>
                    {getStores?.length > 0 ? (getStores?.filter((element) => (element?.storeCode?.toLowerCase().includes(searchName?.toLowerCase()) || element?.storeName?.toLowerCase().includes(searchName?.toLowerCase()))).map((storeData) => {
                        return (
                            <div key={storeData?.storeCode} className='SelectStore-checklist_content' onClick={() => handleSelectStore(storeData)}>
                                <img src={SelectStoreLocationIcon} />
                                <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '14px', lineHeight: '12px', padding: '0px 0px 0px 10px' }}>{storeData?.storeCode}-{storeData?.storeName}</Typography>
                            </div>
                        )
                    })) :
                        (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                                <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                                    <img style={{ heigth: '54px', width: '68px' }} src={NoStoresIcon} alt="" />
                                </div>
                                <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                                    <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Store Available</Typography>
                                </div>
                            </div>
                        )
                    }
                </>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        getStores: state?.checklist?.getStores,
    }
}

export default SelectStoreChecklist